import useAppConfig from "./useAppConfig";
export default () => {
    const { mobileScheme, basePath } = useAppConfig();
    // path does not have a leading slash, can end with query params
    return (path) => `${mobileScheme}:/${basePath}${path}`;
};
